import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sky High NTB";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";

const generateLoanRequestHTML = (profile, loanDetails) => {
  const userLink = `${BASE_URL}/userdetail/${profile.uid}`;
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #2c3d4f, #1a1a1a); color: #ffffff; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 20px; color: #333; font-family: sans-serif; line-height: 1.6; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 15px 0; }
        .info-box p { margin: 10px 0; }
        .label { font-weight: bold; color: #2C3D4F; min-width: 140px; display: inline-block; }
        .btn { display: inline-block; padding: 12px 30px; background: #2C3D4F; color: #ffffff; text-decoration: none; border-radius: 5px; margin: 20px 0; font-weight: bold; }
        .footer { text-align: center; padding: 20px; color: #888; font-size: 12px; }
        h1 { margin: 0; font-size: 24px; }
      </style>
    </head>
    <body>
      <div>
        <div class="header">
          <h1>New Loan Application</h1>
        </div>
        <div class="content">
          <p>A new loan application has been submitted on <strong>${BRAND_NAME}</strong>. Please review the details below:</p>
          
          <div class="info-box">
            <p><span class="label">Applicant Name:</span> ${profile.fullName}</p>
            <p><span class="label">Email:</span> ${profile.email}</p>
            <p><span class="label">Account Number:</span> ${profile.accountNumber}</p>
            <p><span class="label">Amount Requested:</span> ${loanDetails.amount}</p>
            <p><span class="label">Loan Duration:</span> ${loanDetails.duration}</p>
            <p><span class="label">Reason:</span> ${loanDetails.reason}</p>
            <p><span class="label">Other Banks:</span> ${loanDetails.otherBanks || "None"}</p>
            <p><span class="label">Status:</span> ${loanDetails.status.toUpperCase()}</p>
          </div>
          
          <div style="text-align: center;">
            <a href="${userLink}" class="btn">View User Details</a>
          </div>
        </div>
        <div class="footer">
          <p>This is an automated notification from ${BRAND_NAME} System.</p>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendLoanRequestEmail = async (profile, loanDetails) => {
  console.log("📧 Sending loan request notification...", { SUPPORT_EMAIL });
  try {
    const html = generateLoanRequestHTML(profile, loanDetails);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("✅ Loan request notification sent:", response);
    return true;
  } catch (error) {
    console.error("❌ Error sending loan request notification:", error);
    return false;
  }
};
